// ** Initial State
const initialState = {};

const user = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_USER_DETAILS':
    return action.data.data;
  default:
    return { ...state };
  }
};
export default user;
